import { Theme } from "@react-navigation/native";
import { useMemo } from "react";
import { useTheme } from "styled-components";

export const useRootNavigationTheme = () => {
  const theme = useTheme();

  return useMemo<Theme>(
    () => ({
      dark: false,
      colors: {
        primary: theme.colors.basketball,
        background: theme.colors.white,
        card: theme.colors.deepSeaDive,
        text: theme.colors.white,
        border: theme.colors.deepSeaDive,
        notification: theme.colors.basketball,
      },
    }),
    [theme.colors.basketball, theme.colors.deepSeaDive, theme.colors.white]
  );
};
